module.exports = __webpack_public_path__ + "media/images/users/map_smart_phone-38b790d23d6b59367423f9076e7de1ad.png";